export default __webpack_public_path__ + "static/media/babykraken_only_550px-min.c2e40f18.png";